import { gql } from '@apollo/client'
import { CampaignFragment } from '../campaigns'
import { CreatorFragment } from '../fragments/creators'

export const CollaborationFragment = gql`
  fragment CollaborationFragment on Collaboration {
    id
    uuid
    status
    creatorPaymentStatus
    creatorApplicationMessage
    applicationMessageCheckedStatus
    productTrackingLink
    creatorEarningsCents
    creatorEarningsCurrency
    createdAt
    updatedAt
    creator {
      ...CreatorFragment
    }
    campaign {
      ...CampaignFragment
    }
    editsRequestMessage
    secondEditsRequestMessage
    isSecondEditRequestPaid

    hooksCount

    firstVersionClip {
      id
    }
    editedVersionClip {
      id
    }

    hooks {
      description
      creatorPaymentStatus
      creatorEarningsCents
      clipId
    }

    addons {
      description
      creatorPaymentStatus
      creatorEarningsCents
      clipId
    }

    totalCreatorEarningsCents
    pendingCreatorEarningsCents
    paidCreatorEarningsCents

    hooksCount
    uploadedHooksCount
    pendingUploadHooksCount

    addonsCount
    uploadedAddonsCount
    pendingUploadAddonsCount

    isFavorite
    isActive

    isCompleted
    canPurchaseAddons
    remainingDaysForAddonPurchase

    metadata {
      id
      creatorAcceptedAt
      productShippedAt
      productDeliveredAt
      contentUploadedAt
      contentAcceptedAt

      isCreatorAcceptedEmailSent
      isProductDelivered

      productShippedEmailsCount
      pendingContentEmailsToCreatorCount
      pendingContentEmailsToBrandCount
    }
  }
  ${CreatorFragment}
  ${CampaignFragment}
`

export const CollaborationForBrandFragment = gql`
  fragment CollaborationForBrandFragment on Collaboration {
    id
    uuid
    status
    creatorApplicationMessage
    applicationMessageCheckedStatus
    productTrackingLink
    createdAt
    updatedAt
    editsRequestMessage
    secondEditsRequestMessage
    isSecondEditRequestPaid

    hooksCount

    firstVersionClip {
      id
    }
    editedVersionClip {
      id
    }

    hooks {
      description
      creatorPaymentStatus
      creatorEarningsCents
      clipId
    }

    addons {
      description
      creatorPaymentStatus
      creatorEarningsCents
      clipId
    }

    hooksCount
    uploadedHooksCount
    pendingUploadHooksCount

    addonsCount
    uploadedAddonsCount
    pendingUploadAddonsCount

    isFavorite
    isActive

    isCompleted
    canPurchaseAddons
    remainingDaysForAddonPurchase

    metadata {
      id
      creatorAcceptedAt
      productShippedAt
      productDeliveredAt
      contentUploadedAt
      contentAcceptedAt

      isCreatorAcceptedEmailSent
      isProductDelivered

      productShippedEmailsCount
      pendingContentEmailsToCreatorCount
      pendingContentEmailsToBrandCount
    }
  }
`
